import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';

export default function Container(props) {
    return (
        <div data-item="flash">
            {props.children}
        </div>
    );
}

Container.displayName = displayName('FlashMessages/Container');

Container.propTypes = {
    children: PropTypes.any.isRequired,
};
